// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as zod from "zod";

export const addBankFormSchema = zod
  .object({
    mail: zod.any(),
    fullName: zod.string(),
    phoneNumber: zod.preprocess(
      (val) =>
        String(val)
          .slice(1)
          .replaceAll("_", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll(" ", "")
          .trim(),
      zod.string().min(10).optional().or(zod.literal(""))
    ),
    officePhone: zod.preprocess(
      (val) =>
        String(val)
          .slice(1)
          .replaceAll("_", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll(" ", "")
          .trim(),
      zod.string()
    ),
    description: zod.string().optional(),
    // webAddress: zod.string().optional(),
    bankCode: zod.string(),
    parameters: zod.any().array(),
    merchantID: zod.any(),
    mcc: zod.any(),
  })
  .refine(
    (data) => {
      if (!data.merchantID) {
        return !!data.fullName;
      } else {
        return true;
      }
    },
    {
      message: "Passwords don't match",
      path: ["fullName"], // path of error
    }
  )
  .refine(
    (data) => {
      if (!data.merchantID) {
        return !!data.phoneNumber;
      } else {
        return true;
      }
    },
    {
      message: "Passwords don't match",
      path: ["phoneNumber"], // path of error
    }
  )
  .refine(
    (data) => {
      if (!data.merchantID) {
        return !!data.mail;
      } else {
        return true;
      }
    },
    {
      message: "Passwords don't match",
      path: ["mail"], // path of error
    }
  )
  .refine(
    (data) => {
      if (!data.merchantID) {
        return !!data.bankCode;
      } else {
        return !!data.bankCode;
      }
    },
    {
      message: "Passwords don't match",
      path: ["bankCode"], // path of error
    }
  );

export const addSecondBankSchema = zod.object({
  bankCode: zod.string().nonempty(),
  merchantID: zod.number().optional(),
  parameters: zod.any().array(),
});

export const merchantAuthInitialValues: MerchantAuthFormValuesType = {
  merchantId: "",
  bankCodes: [],
  defaultBank: [],
};

export const merchantAuthFormSchema = zod.object({
  merchantId: zod.any(),
  bankCodes: zod.any(),
  defaultBank: zod.any(),
});

export type MerchantAuthFormValuesType = zod.infer<
  typeof merchantAuthFormSchema
>;

export type BankAddFormValuesType = zod.infer<typeof addBankFormSchema>;

export const initialState: BankAddFormValuesType = {
  mail: "",
  fullName: "",
  phoneNumber: "",
  bankCode: "",
  mcc: null,
  description: "",
  parameters: [],
  merchantID: null,
};
const issuerCardBankCodeSchema = zod.object({
  label: zod.string(),
  value: zod.string()
});

export const addBankRedirectFormSchema = zod.object({
  onusRouting: zod.boolean(),
  merchantId: zod.number().optional(),
  issuerCardBankCodes: zod.array(issuerCardBankCodeSchema).nonempty("issuerCardBankCodes alanı zorunludur."),
  issuerCardType: zod
    .string()
    .min(1, { message: "Please enter your phone number" }),
  merchantVposBankCode: zod.string().nonempty("profileCode is required"),
  transactionSubType: zod.string().nonempty("profileCode is required"),
  profileCode: zod.array(zod.string()).nonempty("profileCode is required"),
  mcc: zod.string().optional()
});

export type BankAddRedirectFormValuesType = zod.infer<
  typeof addBankRedirectFormSchema
>;

export const initialBankAddRedirectState: BankAddRedirectFormValuesType = {
  onusRouting: true,
  merchantId: 0,
  issuerCardBankCodes: [],
  issuerCardType: "",
  merchantVposBankCode: "",
  transactionSubType: "",
  profileCode: [],
};
